// extracted by mini-css-extract-plugin
module.exports = {"notice":"TimezoneNotice_notice__2stVL","button":"TimezoneNotice_button__2sS2C"};